import { render } from "./HzbaGroup.vue?vue&type=template&id=5039566a&scoped=true"
import script from "./HzbaGroup.vue?vue&type=script&lang=js"
export * from "./HzbaGroup.vue?vue&type=script&lang=js"

import "./HzbaGroup.vue?vue&type=style&index=0&id=5039566a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5039566a"]])

export default __exports__